<template>
    <div class="addAnchor">
        <el-dialog title="添加主播" :visible.sync="isShow">
            <div class="search">
                <el-input v-model.trim="param.customername" placeholder="输入主播名称" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
            <div class="flex_share">
                <span>最近添加</span>
                <span class="inviteText" @click="invite" v-if="status!=''">邀请微信好友 ></span>
            </div>
            <SharePoup ref="share"></SharePoup>
            <div class="result-list tableList">
                <el-table :data="tableData"  @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column property="" label="用户">
                        <template slot-scope="scope">
                            <div class="anchorHead">
                                <img class="anchorLogo" :src="scope.row.customerurl" alt="">
                                <span>{{scope.row.customername}}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <page :total="total" @getList="_getList" ref="page"></page>
            </div>
            <div class="btn">
                <el-button @click="cancel"  v-if="status!=''">返回</el-button>
                <el-button type="primary" :disabled="islist" @click="addEvent">添加</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getLiveHistoryHeaderList} from 'api/vliveV2Api'
    import Page from 'base/page/page'
    import {mapGetters, mapActions} from 'vuex'
    import SharePoup from '@/views/vliveV2/components/sharePoup'
    export default {
        name: "addAnchor",
        props:['source'],
        data(){
            return{
                isReward:1,
                isShow:false,
                islist:true,
                param:{
                    customername:'', //主播名称
                    liveid:'', //直播id
                },
                tableData:[],
                inviteinfo:{}, //邀请信息
                total: 0,
                multipleSelection:[],
                status:'' //直播状态
            }
        },
        methods:{
            open(id){
                this.param.liveid=id?id:''
                this.status=id
                this._getList()
                this.isShow=true
            },
            //获取可添加列表
            _getList(){
                this.setLoading(true)
                getLiveHistoryHeaderList({
                    data: Object.assign({}, this.param,this.page),
                    success: data => {
                        this.setLoading(false)
                        this.tableData = data.data.headerlist
                        this.inviteinfo=data.data.inviteinfo
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            //邀请微信好友
            invite(){
                this.$refs.share.open(this.inviteinfo);
            },
            //搜索
            handleQuery(){
                this.$refs.page.handleSizeChange(1)
            },
            handleSelectionChange(val) {
                console.log(val)
                this.multipleSelection = val;
                if(val){
                    this.islist=false
                }
            },
            //添加
            addEvent(){
                this.$emit('getTable',this.multipleSelection)
                this.isShow=false
            },
            //取消
            cancel(){
                this.isShow=false
            },
            ...mapActions([
                'setLoading',
            ])
        },
        computed: {
            ...mapGetters([
                'page',
            ])
        },
        components: {
            Page,SharePoup
        },
    }
</script>

<style lang="scss">
    @import "~common/scss/base";
    @import "~common/scss/mixin";
    .addAnchor{
        position: relative;
        .el-dialog {
            width: 700px;
        }
        .el-dialog .el-button{
            margin-bottom: 20px;
        }
        .search{
            display: flex;
            justify-content: space-between;
            .el-input{
                width: 540px;
            }
        }
        .flex_share{
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            color: #666;
            margin-bottom: 10px;
            .inviteText{
                color: #409EFF;
                cursor: pointer;
            }
            .el-button{
                margin-bottom: 0;
                border: none;
                height: auto;
            }
            .el-button:focus, .el-button:hover{
                background: none;
                margin-bottom: 0;
            }
        }
        .result-list{
            .anchorHead{
                display: flex;
                align-items: center;
                color: #666;
                .anchorLogo{
                    min-width: 40px;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
            }
            .delText{
                .cell{
                    text-align: right;
                    span{
                        color: #409EFF;
                        cursor: pointer;
                    }
                }
            }
            .center{
                .cell{
                    text-align: center;
                }
            }
            .el-table td{
                padding: 0 0;
            }
            .el-table__row {
                height: 60px;
            }
        }
        .btn{
            text-align: center;
            padding-top: 20px;
            position: fixed;
            background: #fff;
            width: 700px;
            margin-left: -20px;
        }
    }
</style>
